export const subData = [
  {
    type: 'default',
    name: '预置控件',
    subList: [
      {
        icon: '',
        name: '出生日期',
        type: 'birthday',
        title: '1'
      },
      {
        icon: '',
        name: '政治面貌',
        type: 'politicalStatus',
        title: '1'
      },
      {
        icon: '',
        name: '民族',
        type: 'nation',
        title: '1'
      },
      {
        icon: '',
        name: '层次',
        type: 'level',
        title: '2'
      },
      {
        icon: '',
        name: '专业',
        type: 'subject',
        title: '2',
      },
    ]
  },
  {
    type: 'custom',
    name: '自定义控件',
    subList: [
      {
        icon: 'icon-wenben',
        name: '单行文本',
        type: 'text',
      },
      {
        icon: 'icon-wenben',
        name: '多行文本',
        type: 'textarea',
      },
      {
        icon: 'icon-riqi',
        name: '日期',
        type: 'date'
      },
      {
        icon: 'icon-riqi',
        name: '日期时间',
        type: 'datetime'
      },
      {
        icon: 'icon-xialaxuan',
        name: '下拉选择',
        type: 'select',
      },
      {
        icon: 'icon-xialaxuan',
        name: '省份选择',
        type: 'province'
      },
      {
        icon: 'icon-shengshi',
        name: '省/市',
        type: 'provinceCity'
      },
      {
        icon: 'icon-tupian',
        name: '上传图片',
        type: 'imageUpload'
      },
    ]
  }
]
export const titleName = {
  'select': '下拉框',
  'text': '单行文本',
  'textarea': '多行文本',
  'date':'日期',
  'datetime': '日期时间',
  'province': '省',
  'provinceCity': '省/市',
  'imageUpload': '上传图片'
}
// 系统内置项
export const formData = [
  {
    title: 1,
    titleName: "基本信息",
    formList: [
      {
        defaultValue: null,
        displayName: "姓名",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'text',
        value: "",
      },
      {
        defaultValue: null,
        displayName: "证件类型",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'cardType',
        value: "",
      },
      {
        defaultValue: null,
        displayName: "证件号",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'text',
        value: "",
      },
      {
        defaultValue: null,
        displayName: "性别",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'sex',
        value: "男,女",
      },
      {
        defaultValue: null,
        displayName: "手机号",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'text',
        value: "",
      },
      {
        defaultValue: null,
        displayName: "照片",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        title: 2,
        filesize: 2345,
        remarks: '必须是报考本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功',
        fileBack: ['jepg'],
        type: 'imageUpload',
        value: "",
      },
    ]
  },
  {
    title: 2,
    titleName: "院校信息",
    formList: [
      {
        defaultValue: null,
        displayName: "就读院校",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'school',
        value: "",
      },
      {
        defaultValue: null,
        displayName: "教学点",
        id: "d1b1c731-9922-11ec-bf80-0050568a34f3",
        maxSize: null,
        minSize: null,
        placeholder: null,
        queryCondition: true,
        required: false,
        showInPage: 1,
        sort: 1,
        system: 1,
        title: 2,
        type: 'station',
        value: "",
      },
    ]
  }
]
// type 自定义表单类型 select下拉框 date短日期 datetime 长日期  text文本框  textarea多行文本 province省 provinceCity省、市 birthday出生日期 subject专业 nation民族 politicalStatus政治身份 imageUpload上传图片
// displayName 展示名称 
// extType extType为固定值，用户属性extType = User 
// type 自定义表单类型 1下拉框 2短日期 3长日期 4数字 5文件 6文本框 7多行文本
// value 下拉对应的值
// defaultValue 默认值
// required 是否必填 0否 1是
// minSize 最小长度
// maxSize 最大长度
// showInPage 是否展示 0否 1是
// sort 排序
// system 是否系统内置 0否 1是
// queryCondition 是否查询条件 0否 1是
// title 标题信息 1基本信息 2院校信息
// placeholder 占位提示
// dataType 0文本  1数字 默认0
export const typeForm = {
  'select': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '请选择',
      required: true
    },
    {
      name: 'value',
      defaultValue: '选项一,选项二',
      required: true
    },
    {
      name: 'queryCondition',
      defaultValue: false
    }
  ],
  'text': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '请输入',
      required: true
    },
    {
      name: 'dataType',
      defaultValue: 0,
    },
    {
      name: 'minSize',
    },
    {
      name: 'maxSize',
      defaultValue: 20,
      required: true
    },
    {
      name: 'queryCondition',
      defaultValue: false
    }
  ],
  'textarea': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '请输入',
      required: true
    },
    {
      name: 'minSize',
    },
    {
      name: 'maxSize',
      required: true
    },
  ],
  'date': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '选择日期',
      required: true
    },
  ],
  'datetime': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '选择日期时间',
      required: true
    },
  ],
  'province': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '请选择',
      required: true
    },
    {
      name: 'queryCondition',
      defaultValue: false
    }
  ],
  'provinceCity': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'placeholder',
      defaultValue: '请选择',
      required: true
    },
  ],
  'imageUpload': [
    {
      name: 'title',
      required: true
    },
    {
      name: 'required',
      defaultValue: true, // 0否 1是
    },
    {
      name: 'displayName',
      required: true
    },
    {
      name: 'remarks',
    },
    {
      name: 'filesize',
      defaultValue: 2048,
      required: true
    },
    {
      name: 'fileBack',
      defaultValue: '',
      required: true
    }
  ]
}
